import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import api from "@/lib/api";
import SponsorStrip from "@/components/SponsorStrip";

const cols = [
  {
    title: "Play",
    links: [
      { to: "/events", label: "Upcoming Events" },
      { to: "/where-to-play", label: "Where to Play" },
      { to: "/leaderboards", label: "Leaderboards" },
      { to: "/results", label: "Results" },
      { to: "/seasons", label: "Season Archive" },
    ],
  },
  {
    title: "The League",
    links: [
      { to: "/about", label: "About" },
      { to: "/member-charter", label: "Member Charter" },
      { to: "/rules", label: "Tournament Rules" },
      { to: "/points-payouts", label: "Points / Payouts / Structures" },
    ],
  },
  {
    title: "Join",
    links: [
      { to: "/become-a-legend", label: "Become a Legend" },
      { to: "/become-host", label: "Become a Host Venue" },
      { to: "/gallery", label: "Gallery" },
      { to: "/contact", label: "Contact Us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/responsible-gaming", label: "Responsible Gaming" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
    ],
  },
];

export default function Footer() {
  const [social, setSocial] = useState({});
  useEffect(() => {
    api.get("/content").then((r) => setSocial(r.data?.contact || {})).catch(() => {});
  }, []);
  return (
    <footer className="bg-navy-paper border-t border-white/10 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/legends-logo.png?v=4" alt="Legends Poker" className="h-14 w-14 object-contain" />
              <span className="font-display text-lg font-bold text-white">LEGENDS</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Victoria's home for competitive poker. Play, climb the leaderboard, become a legend.
            </p>
            {(social.facebook || social.instagram) && (
              <div className="flex gap-3 mt-5" data-testid="footer-socials">
                {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-9 h-9 border border-slate-700 hover:border-gold flex items-center justify-center text-slate-400 hover:text-gold transition-colors"><Facebook className="w-4 h-4" /></a>}
                {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-9 h-9 border border-slate-700 hover:border-gold flex items-center justify-center text-slate-400 hover:text-gold transition-colors"><Instagram className="w-4 h-4" /></a>}
              </div>
            )}
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display text-gold text-sm uppercase tracking-widest mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-slate-400 hover:text-gold text-sm transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <SponsorStrip variant="footer" />
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-xs">© {new Date().getFullYear()} Legends Poker League, Victoria. All rights reserved.</p>
          <p className="text-slate-500 text-xs">Gamble responsibly. 18+ only. Call Gambler's Help 1800 858 858.</p>
        </div>
      </div>
    </footer>
  );
}
